<template>
	<div class="menu-item-picker" :class="{ 'is-active': editor.isActive(isActiveString) }" @click="onClick">
		<component :is="ButtonSvg"></component>
	</div>
</template>

<script>
export default {
	name: 'GenericExtensionFormatting',
	props: {
		editor: { type: Object, require: true },
		toggleFunc: { type: String, require: true },
		isActiveString: { type: String, require: true },
		ButtonSvg: { type: Object, require: true },
	},
	methods: {
		onClick() {
			this.editor.chain().focus()[this.toggleFunc]().run();
		},
	},
};
</script>

<style lang="scss" scoped></style>
